import CuratenieCliniciCabineteMedicale from "pages/Servicii/ServiciiSpeciale/CuratenieCliniciCabineteMedicale";

export default function CuratenieCliniciCabineteMedicalePage() {
    return <CuratenieCliniciCabineteMedicale />;
}
